/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisplayUser } from './DisplayUser';
import {
    DisplayUserFromJSON,
    DisplayUserFromJSONTyped,
    DisplayUserToJSON,
} from './DisplayUser';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';

/**
 * 
 * @export
 * @interface PageDisplayUser
 */
export interface PageDisplayUser {
    /**
     * 
     * @type {Array<DisplayUser>}
     * @memberof PageDisplayUser
     */
    results: Array<DisplayUser>;
    /**
     * 
     * @type {number}
     * @memberof PageDisplayUser
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PageDisplayUser
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PageDisplayUser
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PageDisplayUser interface.
 */
export function instanceOfPageDisplayUser(value: object): value is PageDisplayUser {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PageDisplayUserFromJSON(json: any): PageDisplayUser {
    return PageDisplayUserFromJSONTyped(json, false);
}

export function PageDisplayUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDisplayUser {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(DisplayUserFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PageDisplayUserToJSON(value?: PageDisplayUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(DisplayUserToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

